export default "__VITE_ASSET__BbANmPFU__"